import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import CommunicativeSituationsEmbed from '../components/Exercise/CommunicativeSituationsEmbed';

export default Node.create({
  name: 'communicativeSituations',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      title: {
        default: 'Communicative Situation',
      },
      level: {
        default: 'B1',
      },
      topic: {
        default: '',
      },
      vocab: {
        default: '',
      },
      situations: {
        default: [],
        parseHTML: element => {
          const situationsAttr = element.getAttribute('data-situations');
          return situationsAttr ? JSON.parse(situationsAttr) : [];
        },
        renderHTML: attributes => {
          return {
            'data-situations': JSON.stringify(attributes.situations),
          };
        },
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {}
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="communicative-situations"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'communicative-situations' })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CommunicativeSituationsEmbed);
  },
}); 